import { DateField as LibDateField } from 'holistic-resources';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { getInputStyle } from './TextField';

const StyledDateField = styled.div`
  ${(props) => props.customStyles}
  ${(props) => props.defaultStyles}
`;

export default function DateField({
  customStyles,
  onChange,
  onBlur,
  placeholder = 'DD-MM-YYYY',
  name = '',
  id = '',
  timestampValue = null,
  label = '',
  labelClassName = '',
  inputClassName = '',
  errorMessage = '',
  isRequired = false,
  isVisible = true,
  setFormErrorMessages,
  minDate,
  maxDate,
  disabled = false,
}) {
  const { whiteLabelSettings: { secondaryColourDarker } = {} } =
    useWhiteLabelSettings();

  const [fieldId, setFieldId] = useState();

  useEffect(() => {
    setFieldId(id || uuid());
  }, [id]);

  const defaultStyles = `
    input:focus {
      border-color: ${secondaryColourDarker};
    }
    margin: .5rem 0;
    width: 100%;
  `;

  if (!isVisible) {
    return null;
  }

  return (
    <StyledDateField
      customStyles={customStyles}
      defaultStyles={defaultStyles}
    >
      <LibDateField
        minDate={minDate}
        maxDate={maxDate}
        isRequired={isRequired}
        name={name}
        id={fieldId}
        inputClassName={`${inputClassName || getInputStyle(errorMessage)} ${
          disabled
            ? 'pointer-events-none cursor-not-allowed bg-gray-200 text-gray-400 border-gray-300'
            : ''
        }`}
        placeholder={placeholder}
        timestampValue={timestampValue}
        onChange={onChange}
        onBlur={onBlur}
        label={label}
        labelClassName={labelClassName || 'text-gray-500 my-1'}
        errorMessage={errorMessage}
        errorMessageClassName="text-error mt-1 text-[0.8rem]"
        setFormErrorMessages={setFormErrorMessages}
        disabled={disabled}
      />
    </StyledDateField>
  );
}
